export default [
    {
        path: "/voucher/bq-store/sales",
        component: () => import("./List.vue"),
        name: "voucher.bq.store.sales",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/bulk-sales",
        component: () => import("./BulkSale.vue"),
        name: "voucher.bq.store.bulk.sales",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/sales/create",
        component: () => import("./Create.vue"),
        name: "voucher.bq.store.sales.create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/bq-store/sales/other-create",
        component: () => import("./Others.vue"),
        name: "voucher-bq-store-other-sales",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/bq-store/sales/other-free",
        component: () => import("./PosCounter.vue"),
        name: "voucher-bq-store-other-free",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/bq-store/purchase-return/create",
        component: () => import("./PurchaseReturn.vue"),
        name: "voucher.bq.store.purchase.return.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/sales/:id/edit",
        component: () => import("./Edit.vue"),
        name: "voucher.bq.store.sales.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/bq-store/sales/:id/view",
        component: () => import("./View.vue"),
        name: "voucher.bq.store.sales.view",
        meta: {
            requiresAuth: true,
        },
    },
];
